export default {
    name: 'magic_usecase',
    max_duration: '777',
    environment_config_id: '1',
    main_area_name: 'World',
    main_area_lon: '-75.553948',
    main_area_lat: '45.444838',
    areas: [
        {
            name: 'Protected Zone',
            type: 'Protected',
            polygon: [
                { lat: '45.444746900870065', lon: '-75.55769920349121' },
                { lat: '45.44634266942319', lon: '-75.55164813995361' },
                { lat: '45.450527583830095', lon: '-75.55452346801758' },
                { lat: '45.44917278941327', lon: '-75.56005954742432' },
                { lat: '45.444746900870065', lon: '-75.55769920349121' },
            ],
        },
        {
            name: 'Buffer Zone',
            type: 'Buffer',
            polygon: [
                { lat: '45.43782134452245', lon: '-75.5553388595581' },
                { lat: '45.44053144607459', lon: '-75.54641246795654' },
                { lat: '45.45209308351625', lon: '-75.55276393890381' },
                { lat: '45.44956417780963', lon: '-75.56216239929199' },
                { lat: '45.43782134452245', lon: '-75.5553388595581' },
            ],
        },
    ],
    payload_assets: [
        {
            name: 'GroundRadar',
            type: 'Sensor',
            model: 'Echoguard',
            position: { lat: '45.44917003', lon: '-75.55666528', alt: '130' },
            actions_orient: [],
            actions_look: [],
            actions_zoom: [],
            actions_get_detection: [],
        },
        {
            name: 'Sensor1',
            type: 'Sensor',
            model: 'EmbeddedGimbal',
            position: { lat: '', lon: '', alt: '' },
            actions_orient: [],
            actions_look: [],
            actions_zoom: [],
            actions_get_detection: [],
        },
    ],
    platform_assets: [
        {
            name: 'MagicGCS',
            type: 'GCS',
            model: '@ModelGCS',
            position: { lat: '45.44917003', lon: '-75.55666528', alt: '130' },
            actions_goto: [],
            actions_neutralization: [],
            actions_get_telemetry: [],
            sparq_id: 'Default',
            payload: [],
        },
        {
            name: 'BlueDrone',
            type: 'Drone',
            model: 'BlueDrone',
            position: { lat: '45.44790808', lon: '-75.55662532', alt: '130' },
            actions_goto: [],
            actions_neutralization: [],
            actions_get_telemetry: [],
            sparq_id: '',
            payload: [],
        },
    ],
    threats: [
        {
            name: 'RedDrone',
            type: 'Drone',
            model: 'RedDrone',
            initial_position: { lat: '45.43906953', lon: '-75.55119887', alt: '130' },
            waypoints: [
                { lat: '45.44149377', lon: '-75.54822125', alt: '130', vel: '1' },
                { lat: '45.44101527', lon: '-75.55658116', alt: '130', vel: '1' },
                { lat: '45.44511779', lon: '-75.55016967', alt: '130', vel: '1' },
            ],
            actions_goto: [],
            actions_get_telemetry: [],
            sparq_id: '',
        },
    ],
}
